import { useNavigate } from 'react-router-dom';

import { Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material';
import { useMutation, useQueryClient } from '@tanstack/react-query';

import { ActionButton } from 'commonComponents/ActionButton';

import { removeObjectFromReactQueryCache } from 'api/cache';
import { deleteProductConfiguration } from 'api/productConfigurations';
import { DeleteIcon, UndoIcon } from 'icons';
import { ROUTES } from 'routes/routes';

export function ConfigurationDeleteDialog({ configuration, open, onClose }) {
    const queryClient = useQueryClient();
    const { mutate, isPending: isLoading } = useMutation({
        mutationFn: () => deleteProductConfiguration(configuration.id),
        onSuccess: () => {
            removeObjectFromReactQueryCache(queryClient, configuration.id, 'ProductConfiguration');
            onClose();
            navigate(ROUTES.CONFIGURATION_LIST);
        },
        meta: { errorMessage: 'Deleting configuration failed' },
    });
    const navigate = useNavigate();

    return (
        <Dialog {...{ open, onClose }}>
            <DialogTitle>Delete Product Configuration</DialogTitle>
            <DialogContent>Delete this product configuration?</DialogContent>
            <DialogActions>
                <ActionButton
                    color="secondary"
                    iconClass={DeleteIcon}
                    disabled={isLoading}
                    inProgress={isLoading}
                    title="Delete"
                    variant="contained"
                    type="submit"
                    onClick={() => mutate()}
                />
                <ActionButton
                    color="primary"
                    iconClass={UndoIcon}
                    inProgress={false}
                    onClick={onClose}
                    title="Cancel"
                    variant="contained"
                />
            </DialogActions>
        </Dialog>
    );
}
